import React, { useEffect, useState } from "react";
import back from "../../Asset/product/back.png";
import cartModel from "../../model/cart.model";
import Items from "../../component/cart/Items";
import DeleveryAddress from "../../component/cart/DeleveryAddress";
import PaymentMethod from "../../component/cart/PaymentMethod";
import CoupleCode from "../../component/cart/CoupleCode";
import OrderSummery from "../../component/cart/OrderSummery";
import { useLocation, useNavigate } from "react-router-dom";
import orderModel from "../../model/order.model";
import { toast } from "../../lib/helper";
import address from "../../Asset/toast/address.png"
import paymentmode from "../../Asset/toast/paymentmode.png"
import logo from "../../Asset/ordercard/logo.png";
import wrong from "../../Asset/toast/wrong.png"
import nocart from "../../Asset/toast/nocart.png"
import { FaShoppingCart } from "react-icons/fa";
import cart2 from "../../Asset/recent/cart2.png";
import { BiSolidPurchaseTag } from "react-icons/bi";

const Cart = () => {
  const [cartlist, setCartList] = useState();
  const [Address, setAddress] = useState();
  const [paymentmethod, setPaymentmethod] = useState("");
  const [couponCode, setCouponCode] = useState("");
  const [newSummery, setNewSummery] = useState("");
  const Navigate = useNavigate();
  const location = useLocation();
  const [couponOn, setCouponOn] = useState(false);
  const [loading, setLoading] = useState(false);
const[Loadings,setloadings]=useState(false)
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location?.pathname]);

  const Getcart = async () => {
    setLoading(true);
    cartModel
      .GetCart("regular")
      .then((responce) => {
        setCartList(responce?.data?.data);
        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
        console.log("error", error);
      });
  };
  useEffect(() => {
    Getcart();
  }, []);

  const PlaceOrder = async () => {
        if(!Address?._id){
      toast("Please select a Address.", address);
        return;
    }
    if (!paymentmethod) {
        toast("Please select a Payment Mode.", paymentmode);
        return;
      }
    setloadings(true);

    const form = new FormData();
    form.append("delivery_address", Address?._id);
    form.append("payment_method", paymentmethod);
    form.append("coupon_code", couponCode);
    if (location?.pathname == "/cart") {
      form.append("cart_type", "regular");
    }
    orderModel
      .PlaceOrder(form)
      .then((responce) => {
        
        sessionStorage.setItem("neworderid", responce?.data?.newOrder?._id);
        sessionStorage.setItem("showOrderPopup", "true");
        setloadings(false);
        Navigate("/");
        console.log("ressss place order", responce);
      })
      .catch((error) => {
        toast(error?.response?.data?.message,"warning");
        console.log("error", error);
        setloadings(false);
      });
  };
  const Validatecouple = async () => {
    const form = new FormData();
    form.append("coupon_code", couponCode);
    form.append("cart_type", "regular");
    cartModel
      .Validatecoupun(form)
      .then((responce) => {
        toast(responce?.data?.message, logo);
        setNewSummery(responce?.data?.data);
        console.log("gggg", responce);
      })
      .catch((error) => {
        toast(error?.response?.data?.message, wrong);
        console.log("error", error);
      });
  };
  useEffect(() => {
    if (couponCode && couponOn) {
      Validatecouple();
    }
  }, [couponCode]);

  return (
    <div
      className="w-full pt-32  bg-[#f1f2eb] pl-8 pr-8  pb-44 lg:pl-20 lg:pr-20 lg:pt-30 lg:pb-52"
      style={{
        backgroundImage: `url(${back})`,
        backgroundRepeat: "repeat",
        backgroundSize: "auto",
      }}
    >
      <div className=" w-full md:w-3/4 flex gap-2 bg-Background1 p-2 lg:p-3 rounded-xl">
        <span
          className="title1 w-44 py-1  flex hover:bg-Background2 items-center gap-2 justify-center bg-Background2 text-lg md:text-xl font-bold text-textColor text-center rounded-lg cursor-pointer"
          onClick={() => {
            Navigate("/cart");
          }}
        >
        <FaShoppingCart />  Cart
        </span>
        <span
          className="title1 w-44 flex items-center justify-center gap-1 hover:bg-Background2 text-lg md:text-xl font-bold text-textColor text-center rounded-lg cursor-pointer py-1 "
          onClick={() => {
            Navigate("/preorder");
          }}
        >
              <div className="w-6 ">
               
                <img src={cart2} alt="" className="w-full h-full object-cover" />
                
              </div>
          Pre Order Cart
        </span>
        <span
          className="title1 w-44 flex justify-center items-center gap-2 hover:bg-Background2  text-lg md:text-xl font-bold text-textColor text-center rounded-lg cursor-pointer py-1 "
          onClick={() => {
            Navigate("/subscribe");
          }}
        >
        <BiSolidPurchaseTag />  Subscribe
        </span>
      </div>
      {loading ? (
        <div className="w-full py-36 flex items-center justify-center">
          <span className="loading loading-ring loading-xs"></span>
          <span className="loading loading-ring loading-sm"></span>
          <span className="loading loading-ring loading-md"></span>
          <span className="loading loading-ring loading-lg"></span>
          <span className="loading loading-ring loading-xl"></span>
          <span className="loading loading-ring loading-lg"></span>
          <span className="loading loading-ring loading-md"></span>
          <span className="loading loading-ring loading-sm"></span>
          <span className="loading loading-ring loading-xs"></span>
        </div>
      ) : cartlist?.cart_items.length > 0 ? (
        <div className="w-full flex justify-center items-center">
        <div className="w-[98%]" >
          {/* items section */}
          <div className="mt-5 w-full">
            <Items
              datalist={cartlist?.cart_items}
              Getcart={Getcart}
              setNewSummery={setNewSummery}
              setCouponCode={setCouponCode}
            />
          </div>
          {/*second section*/}
          <div className="grid gap-20 grid-cols-1 lg:grid-cols-2">
            {/*left*/}
            <div className="w-full flex flex-col gap-4 mt-8 md:mt-0">
              <DeleveryAddress setAddress={setAddress} Address={Address} />
              <PaymentMethod
                setPaymentmethod={setPaymentmethod}
                paymentmethod={paymentmethod}
              />
              <CoupleCode
                newSummery={newSummery}
                setNewSummery={setNewSummery}
                couponCode={couponCode}
                setCouponCode={setCouponCode}
                Validatecouple={Validatecouple}
                couponOn={couponOn}
                setCouponOn={setCouponOn}
              />
            </div>
            {/*right*/}
            <div className="w-full  flex flex-col gap-6">
              <OrderSummery
                summery={cartlist?.cart_summary}
                newSummery={newSummery}
              />
              <div className="w-full">
                <button
                  className="bg-textColor text-white font-semibold w-full py-2 rounded-2xl title2"
                  onClick={PlaceOrder}
                >
                   {Loadings ? <span className="loading loading-dots loading-sm"></span> : "Place Order"} 
                </button>
              </div>
            </div>
          </div>
        </div>
        </div>
      ) : (
        <div
          className="w-full py-36 flex gap-2 justify-center"
          >
          
          <div className="flex items-center">
          <span className="text-lg font-semibold text-textColor">
            No Item in Cart
          </span> </div>
        </div>
      )}
    </div>
  );
};

export default Cart;
